<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg4077"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs4081"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath4091"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path4089" /></clipPath></defs><g
     id="g4083"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g4085"><g
         id="g4087"
         clip-path="url(#clipPath4091)"><g
           id="g4093"
           transform="translate(30,421.4609)"><path
             d="m 0,0 v 43.039 c 0,22.09 17.91,40 40,40 h 214 c 22.09,0 40,-17.91 40,-40 v -39.5"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4095" /></g><g
           id="g4097"
           transform="translate(324,185)"><path
             d="m 0,0 v -137.5 c 0,-22.09 -17.91,-40 -40,-40 h -214 c -22.09,0 -40,17.91 -40,40 V 201"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4099" /></g><g
           id="g4101"
           transform="translate(298,70.9502)"><path
             d="m 0,0 v -23.45 c 0,-7.731 -6.27,-14 -14,-14 h -214 c -7.73,0 -14,6.269 -14,14 v 417 c 0,7.73 6.27,14 14,14 h 40.1 c 2.34,0 4.41,-1.481 5.17,-3.68 l 5.28,-15.36 c 0.76,-2.2 2.83,-3.68 5.17,-3.68 h 102.56 c 2.34,0 4.41,1.48 5.17,3.68 l 5.28,15.36 c 0.76,2.199 2.83,3.68 5.17,3.68 H -14 c 7.73,0 14,-6.27 14,-14 v -39.5"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4103" /></g><g
           id="g4105"
           transform="translate(298,185)"><path
             d="M 0,0 V -79.073"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4107" /></g><g
           id="g4109"
           transform="translate(216,98)"><path
             d="m 0,0 h -78 c -11.598,0 -21,9.402 -21,21 0,11.598 9.402,21 21,21 H 0 C 11.598,42 21,32.598 21,21 21,9.402 11.598,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4111" /></g><g
           id="g4113"
           transform="translate(424.1914,425)"><path
             d="M 0,0 H 38.178 C 49.02,0 57.809,-8.789 57.809,-19.631 V -220.369 C 57.809,-231.211 49.02,-240 38.178,-240 h -344.739 c -10.841,0 -19.63,8.789 -19.63,19.631 v 200.738 c 0,10.842 8.789,19.631 19.63,19.631 h 271.305"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4115" /></g><g
           id="g4117"
           transform="translate(349.8496,219.2539)"><path
             d="m 0,0 21.719,57.024 c 0.443,1.085 1.979,1.087 2.426,0.003 L 45.665,0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4119" /></g><g
           id="g4121"
           transform="translate(356.623,233.4561)"><path
             d="M 0,0 H 32.228"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4123" /></g><g
           id="g4125"
           transform="translate(404.6963,277.0928)"><path
             d="M 0,0 18.475,-28.294 36.798,-0.146"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4127" /></g><g
           id="g4129"
           transform="translate(423.0986,219.2539)"><path
             d="M 0,0 0.072,29.545"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4131" /></g><g
           id="g4133"
           transform="translate(307.9219,268.0732)"><path
             d="M 0,0 V -48.819"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4135" /></g><g
           id="g4137"
           transform="translate(340.668,260.7705)"><path
             d="m 0,0 c 0,-9.014 -7.627,-16.322 -16.642,-16.322 -4.47,0 -15.992,-0.072 -15.992,-0.072 0,0 -0.072,11.85 -0.072,16.394 0,3.732 -0.04,16.322 -0.04,16.322 h 16.104 C -7.627,16.322 0,9.015 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4139" /></g><g
           id="g4141"
           transform="translate(211,334)"><path
             d="m 0,0 h -62 c -3.313,0 -6,2.687 -6,6 v 40 c 0,3.313 2.687,6 6,6 H 0 c 3.313,0 6,-2.687 6,-6 V 6 C 6,2.687 3.313,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4143" /></g><g
           id="g4145"
           transform="translate(186,222.1738)"><path
             d="M 0,0 H -88 V 52 H 0 C 14.359,52 26,40.359 26,26 26,11.641 14.359,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4147" /></g><g
           id="g4149"
           transform="translate(281.4043,367.9307)"><path
             d="M 0,0 V -12"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4151" /></g><g
           id="g4153"
           transform="translate(405.1064,367.9307)"><path
             d="M 0,0 V -12"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4155" /></g><g
           id="g4157"
           transform="translate(431.8418,367.9307)"><path
             d="M 0,0 V -12"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4159" /></g><g
           id="g4161"
           transform="translate(320.2227,367.9307)"><path
             d="M 0,0 V -12"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4163" /></g><g
           id="g4165"
           transform="translate(348.5596,367.9307)"><path
             d="M 0,0 V -12"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4167" /></g></g></g></g></svg>
</template>
